module.exports = __webpack_public_path__ + "static/amazon-appstore-badge-de-black-be16544c90a43d9ec9014f6c4011523c.svg";